import { UserCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  birth_date: {
    "ui:field": "date",
  },
  cellphone: {
    "ui:options": {
      inputMode: "numeric", // کیبورد عددی باز می‌شود
      pattern: "[0-9]*", // برای دستگاه‌های iOS
    },
  },
  national_code: {
    "ui:options": {
      inputMode: "numeric", // کیبورد عددی باز می‌شود
      pattern: "[0-9]*", // برای دستگاه‌های iOS
    },
  },
  user_category_id: {
      'ui:widget': UserCategorySelectionWidget,
    },
});

export default uiSchema;
